



































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson, resetObjValue2NoneString, deepCopy } from '@/utils/tool'
import { EStateColor } from '../../../typings/enum'
import { IResApp } from '@/api/files/files-app/res'
import {
  getIosList,
  getIosSource,
  getAppStatus,
  deleteIosApp
} from '@/api/files/files-app/filesApp'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'

@Component({
  name: 'FilesAppIos'
})
export default class extends mixins(DateOption) {
  // data
  private params: any = {
    id: '',
    name: '',
    appleId: '',
    source: '',
    status: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private tableData: IResApp[] = []
  private totalCount: number = 0
  routeQuery: IQuery = { id: 0, platform: 'ios' }
  private dateArray: string[] = ['', '']
  private sourceList: Array<ISelectItem> = []
  private options: Array<ISelectItem> = []
  public stateColor = EStateColor
  tableLoading = false
  operation: string = ''
  openWindow: any
  tableHeight: number = 500
  selectedData: any[] = []

  // lifecycle
  created() {
    this.getTableData()
    this.getIosSource()
    this.getAppStatus()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res: any = await getIosList(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.icon = cover
      this.tableData.push(el)
    })
    this.totalCount = res.data.pageInfo.totalCount
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].icon, header).then(res => {
        this.tableData[i]['icon'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  async getIosSource() {
    let res = await getIosSource()
    this.sourceList = res.data.dataList
  }
  async getAppStatus() {
    let res = await getAppStatus()
    this.options = res.data
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  handleDateChange(date: string[] | any) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleInput(val: string, attr: string) {
    this.params[attr] = val.replace(/[^0-9]/g, '')
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleOperate(val: string) {
    if (this.selectedData.length > 0) {
      let ids = this.selectedData.map((s: any) => s.id).toString()
      this.deleteApp(ids)
    }
  }
  goToDetail(item: IResApp) {
    this.routeQuery.id = item.id
    this.openWindow({
      name: 'AppDetail',
      query: this.routeQuery
    })
  }
  goToAdd() {
    this.openWindow({
      name: 'AddApp',
      query: {
        platform: 'ios'
      }
    })
  }
  editApp(item: IResApp) {
    this.routeQuery.id = item.id
    this.openWindow({
      name: 'EditApp',
      query: this.routeQuery
    })
  }
  deleteApp(ids: string) {
    this.$confirm('是否删除？/ 批量删除吗？', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteIosApp({
          ids: ids
        })
        this.operation = ''
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
  handleSelectionChange(val: any[]) {
    this.selectedData = val
  }
  handleSelectAll() {
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }

  private async handleExcel() {
    let excelParams = deepCopy(this.params)
    let res: any = await getIosList(
      Object.assign(excelParams, {
        page: 1,
        pageCount: 3000
      })
    )
    if (res.status.code === 0) {
      this['$message'].success('导出成功')
    } else {
      this['$message'].error('导出失败')
      return
    }
    const filterVal: string[] = [
      'id',
      'name',
      'developer',
      'category',
      'source',
      'version',
      'price',
      'socre',
      'status',
      'editor',
      'updateDate'
    ]
    const theader: string[] = [
      'ID',
      '名称',
      '开发者',
      '类别',
      '来源',
      '版本',
      '价格',
      '评分',
      '应用状态',
      '编辑人',
      '最后修改时间'
    ]
    const list = res.data.dataList
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
  }
}
